import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import Button from '../Button';
import './styles.styl';

class Modal extends Component {
  handleKeyDown = e => {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.props.onClose();
    }
  };

  render() {
    const { data, onClose } = this.props;

    return (
      <Fragment>
        <div
          className="comet-modal-overlay comet-modal-overlay--backdrop"
          onClick={onClose}
          onKeyDown={this.handleKeyDown}
          role="presentation"
        />

        <FocusTrap>
          <div // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
            className="comet-modal js-comet-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            tabIndex="-1"
            ref={m => {
              this.modal = m;
            }}
            onKeyDown={this.handleKeyDown}
          >
            <div className="comet-modal__inner">
              <div className="comet-modal__header comet-long-form-text">
                <h3 className="comet-modal__header-content" id="modal-title">
                  {data.title}
                </h3>
              </div>

              <div className="comet-modal__content comet-long-form-text">
                <div className="modal-image-container margin-m">
                  <img src={data.image} alt={data.imageText} />
                </div>
                {data.text}
              </div>

              <div className="comet-modal__footer">
                <div className="modal-button-container">
                  <Button onClick={onClose}>
                    {data.buttonText || 'Close'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      </Fragment>
    );
  }
}

Modal.defaultProps = {};

Modal.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export default Modal;



// WEBPACK FOOTER //
// ../core/src/components/Modal/Modal.js